/**
 * linking.js - putting records under a main project by hand (10/14/26).
 * Each link is an ordinary save of that record's Main project (parent_id)
 * through AppContext.saveProject - PUT /api/projects/:id - so every change
 * is one Activity entry per record with its Revert, a live update, the
 * Projects / Opportunities Edit check, and the edit-conflict guard: it
 * expects the Main project the screen showed, so a record someone else moved
 * meanwhile is not moved again silently.
 */
import { parentIdOf, recordLabel } from '../../../data/projectHierarchy';

/** Set one record's Main project (null / '' = on its own). Answers saveProject's { ok, status, body }. */
export function setMainProject(saveProject, record, parentId) {
  return saveProject(record.id, { parentId: parentId || null }, { expect: { parentId: parentIdOf(record) } });
}

/**
 * Set the Main project of several records, one save each, in order.
 * Returns { done: [record], failed: [{ record, error }] }.
 */
export async function setMainProjectOfMany(saveProject, records, parentId) {
  const done = [];
  const failed = [];
  for (const r of records || []) {
    let res;
    try {
      res = await setMainProject(saveProject, r, parentId);
    } catch {
      res = { ok: false, body: null };
    }
    if (res && res.ok) done.push(r);
    else {
      const why =
        res && res.body && res.body.code === 'edit_conflict'
          ? 'someone else changed it meanwhile - look again'
          : (res && res.body && res.body.error) || 'could not save';
      failed.push({ record: r, error: `${recordLabel(r)}: ${why}` });
    }
  }
  return { done, failed };
}
